import React, {useEffect} from 'react'


export default props => {
	const { orderTotal } = props

	useEffect(() => {
		if(window.paypal && window.paypal.Messages){
			window.paypal.Messages({
				amount: orderTotal.amount,
				placement: "product",
				buyerCountry: "US",
				style: {
				  layout: "text",
				  logo: {
					type: "inline",
				  },
				}
			  }).render("#pp-pay-later-message");
		}
	} , [orderTotal.amount])
    
	return <div className="pp-message" id="pp-pay-later-message"></div>
}